<template>
    <PopForm v-show="state" :title="title" body-max-height="200px" width="460px" class="select-tree-box">
        <div class="tree-data-box">
            <el-tree ref="treeDom"
                     :data="treeData" :default-expanded-keys="checkedArr" :default-checked-keys="checkedArr"
                     :node-key="keyName" :props="dataField" show-checkbox :check-on-click-node="true"
                     @check-change="handleCheckChange">
            </el-tree>
        </div>

        <template #foot>
            <div class="bottom-box">
                <div class="left-box">
                    <el-checkbox v-model="checkAll" @change="checkAllEvent">全选</el-checkbox>
                </div>
                <div class="right-box">
                    <el-button type="primary" @click="submit">确定</el-button>
                    <el-button @click="close">取消</el-button>
                </div>
            </div>
        </template>
    </PopForm>
</template>

<script>
    import PopForm from "@/model/PopForm";
    export default {
        name: "SelectTree",
        components: {PopForm},
        model: {
            prop: "state",
            event: "showChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            checkedArr: {   //默认选中的ID集合
                type: Array,
                default: () => ([])
            },
            title: {
                type: String,
                default: "请选择"
            },
            treeData: {
                type: Array,
                default: () => []
            },
            keyName: {
                type: String,
                default: "id"
            },
            labelName: {
                type: String,
                default: "label"
            },
            childrenName: {
                type: String,
                default: "children"
            }
        },
        data: () => ({
            // treeData: [
                // {
                //     id: 1,
                //     label: "node1",
                //     children: [
                //         {
                //             id: 1.1,
                //             label: "node1-1"
                //         }
                //     ]
                // }
            // ],
            // dataField: {
            //     label: "store_name",
            //     children: "children"
            // },

            checkedData: [],    //当前选中的ID集合
            checkAll: false
        }),
        computed:{
            dataField(){
                return {
                    label: this.labelName,
                    children: this.childrenName
                };
            }
        },
        methods: {
            //选中状态发生改变
            handleCheckChange(data, checked, indeterminate){
                this.syncData();
            },
            //同步选中的数据
            syncData(){
                let checkedData = [];
                let allCheckedData = this.$refs.treeDom.getCheckedNodes();
                allCheckedData.forEach(val => {
                    checkedData.push(val.id);
                });

                this.checkAll = checkedData.length === this.treeData.length;
                this.checkedData = checkedData;
            },

            //选中所有
            checkAllEvent(state){
                for (let i in this.treeData) {
                    if(state)
                        this.$refs.treeDom.setChecked(this.treeData[i].id, true, true);
                    else
                        this.$refs.treeDom.setChecked(this.treeData[i].id, false, true);
                }
            },
            //关闭
            close(){
                this.$emit("showChange", false);
            },
            //提交
            submit(){
                this.$emit("checked", this.checkedData);
                this.close();
            },
        },
        watch: {
            state(val){
                if(val) {
                    this.checkedData = this.checkedArr;
                    this.$refs["treeDom"].setCheckedKeys(this.checkedData);
                    this.syncData();
                }
            },
        }
    }
</script>

<style scoped>
    .select-tree-box{
        line-height: normal;
    }
    .bottom-box{
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        padding: 0px 10px;
    }
    .bottom-box>.left-box{
        flex: 1;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
    }
    .bottom-box>.right-box{
        flex: 2;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
    }
    .tree-data-box{
        line-height: 35px;
    }
</style>
<style>
    .tree-data-box .el-checkbox{
        margin-right: 8px;
    }
</style>
